export default __webpack_public_path__ + "static/media/ret_sta_2.96b9eea8.jpeg";